import React from "react";

// 1. Import all 16 images from your assets folder.
// Note: Make sure the file extension (.jpg, .png, etc.) is correct.
import img1 from "../assets/kavugallarylow/img1.webp";
import img2 from "../assets/kavugallarylow/img2.webp";
import img3 from "../assets/kavugallarylow/img3.webp";
import img4 from "../assets/kavugallarylow/img4.webp";
import img5 from "../assets/kavugallarylow/img5.webp";
import img6 from "../assets/kavugallarylow/img6.webp";
import img7 from "../assets/kavugallarylow/img7.webp";
import img8 from "../assets/kavugallarylow/img8.webp";
import img9 from "../assets/kavugallarylow/img9.webp";
import img10 from "../assets/kavugallarylow/img10.webp";
import img11 from "../assets/kavugallarylow/img11.webp";
import img12 from "../assets/kavugallarylow/img12.webp";
import img13 from "../assets/kavugallarylow/img13.webp";
import img14 from "../assets/kavugallarylow/img14.webp";
import img15 from "../assets/kavugallarylow/img15.webp";
import img16 from "../assets/kavugallarylow/img16.webp";
import img17 from "../assets/kavugallarylow/img17.webp";
import img18 from "../assets/kavugallarylow/img18.webp";
import img19 from "../assets/kavugallarylow/img19.webp";
import img20 from "../assets/kavugallarylow/img20.webp";
import img21 from "../assets/kavugallarylow/img21.webp";
import img22 from "../assets/kavugallarylow/img22.webp";

const Gallery = () => {
  // 2. Create an array containing your imported images.
  const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
  ];

  // 3. Map over the images array to generate the gallery items.
  const galleryItems = images.map((image, i) => (
    <div key={i} className="gallery-item">
      <img src={image} alt={`Gallery background item ${i + 1}`} />
    </div>
  ));

  return (
    <div className="page" id="page7">
      <div className="image-gallery-grid">{galleryItems}</div>
      <h2 className="gallery-overlay-title">
        {/* 4. The link now points to your app's gallery page. */}
        <a href="/gallery" style={{ color: "inherit", textDecoration: "none" }}>
          <span style={{ fontFamily: "'Brush Script MT', cursive" }}>
            Image Gallery
          </span>
        
        </a>
      </h2>
    </div>
  );
};

export default Gallery;
